module.exports = __webpack_public_path__ + "static/media/icon-cancelled.da43338e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-cancelled.svg
// module id = 933
// module chunks = 0